import { formatSaveDateFrom, formatSaveDateTo } from 'reducers/TimeReducer';
import { ReportIdConst } from '../../enums/report.enum';

export const processParameters = (ReportID, formData, format = 'report') => {
  switch (ReportID) {
    case ReportIdConst.CitationReport:
      return processCitationReportData(formData, format);

    case ReportIdConst.ActiveWarrantListWithMugshot:
    case ReportIdConst.ActiveWarrantReport:
      return processWarrantReportData(formData, format);

    case ReportIdConst.IncidentByLocationSummary:
    case ReportIdConst.IncidentByLocationDetail:
      return processIncidentByLocationData(formData, format);

    case ReportIdConst.IncidentSeverityByZone:
      return processIncidentSeverityByZonesData(formData, format);

    case ReportIdConst.OffenseChargesByState:
    case ReportIdConst.OffenseChargesByCity:
      return processOffenseChanreByStateData(formData, format);

    // We do not have any report for this ID 281 and 282 so do not consider it
    // case '281':
    // case '282':
    //   return processOfficerActivityReportData(formData, format);

    case ReportIdConst.CitationStatisticsReport:
      return processCitationReportData(formData, format);

    case ReportIdConst.CleryReport:
      return processCleryReportData(formData, format);
    default:
      return {};
  }
};

const processCleryReportData = (formData, format) => 
{
  if(!formData) return {};

  const newForm =
  {
    startDate: formatDate(formData.startDate, 'from', format),
    endDate: formatDate(formData.endDate, 'to', format),
  }
  return newForm;
}

const processCitationReportData = (formData, format) => {
  if (!formData) return {};
  // console.log('formdata', formData);
  const newForm = {
    citationDateFrom: formatDate(formData.citationDateFrom, 'from', format),
    citationDateTo: formatDate(formData.citationDateTo, 'to', format),
    parties: extractListWithId(formData.parties, 'ptsPersonID'),
    partyTypes: extractListWithId(formData.partyTypes, 'Code'),
    citationTypes: extractListWithId(formData.citationTypes, 'Code'),
    Offenses: extractListWithId(formData.offenses, 'ptsStatuteID'),
    sex: formData.sex?.Code || '',
    race: formData.race?.Code || '',
    ethnicity: formData.ethnicity?.Code || '',
    make: formData.make || '',
    vehiclemodel: formData.model || '',
    plateNumber: formData.plateNumber || '',
  };
  return newForm;
};

const processWarrantReportData = (formData, format) => {
  if (!formData) return {};

  const newForm = {
    issuedDateFrom: formatDate(formData.issuedDateFrom, 'from', format),
    issuedDateTo: formatDate(formData.issuedDateTo, 'to', format),
    offenseSeverities: extractListWithId(formData.offenseSeverities, 'Code'),
    heldBy: extractListWithId(formData.heldBy, 'ptsPlaceID'),
    dispositions: extractListWithId(formData.dispositions, 'Code'),
    parties: extractListWithId(formData.parties, 'ptsPersonID'),
    partyTypes: extractListWithId(formData.partyTypes, 'Code'),
    Offenses: extractListWithId(formData.offenses, 'ptsStatuteID'),
  };
  return newForm;
};
const processIncidentByLocationData = (formData, format) => {
  if (!formData) return {};

  const newForm = {
    createdDateFrom: formatDate(formData.receivedFromBeginning, 'from', format),
    createdDateTo: formatDate(formData.receivedFromEnding, 'to', format),
    locationCategories: extractListWithId(formData.locationCategories, 'Code'),
    zones: extractListWithId(formData.zones, 'ZoneCode'),
    topRows: formData.topRows ?? '',
  };
  return newForm;
};
const processIncidentSeverityByZonesData = (formData, format) => {
  if (!formData) return {};

  const newForm = {
    createdDateFrom: formatDate(formData.occurredFromBeginning, 'from', format),
    createdDateTo: formatDate(formData.occurredFromEnding, 'to', format),
    offenseSeverities: extractListWithId(formData.offenseSeverities, 'Code'),
    Offenses: extractListWithId(formData.offenses, 'ptsStatuteID'),
  };
  return newForm;
};
const processOffenseChanreByStateData = (formData, format) => {
  if (!formData) return {};
  const newForm = {
    offenseDateFrom: formatDate(formData.offenseDateFrom, 'from', format),
    offenseDateTo: formatDate(formData.offenseDateTo, 'to', format),
    arrestDateFrom: formatDate(formData.arrestDateFrom, 'from', format),
    arrestDateTo: formatDate(formData.arrestDateTo, 'to', format),
    locationCategories: extractListWithId(formData.locationCategories, 'Code'),
    zones: extractListWithId(formData.zones, 'ZoneCode'),
    Offenses: extractListWithId(formData.offenses, 'ptsStatuteID'),
    offenderHomeStates: extractListWithId(formData.offenderHomeStates, 'Code'),
  };
  return newForm;
};

const processOfficerActivityReportData = (formData, format) => {
  if (!formData) return {};

  const newForm = {
    createdDateFrom: formatDate(formData.dateFrom, 'from', format),
    createdDateTo: formatDate(formData.dateTo, 'to', format),
    officer: extractListWithId(formData.officers, 'ptsPersonID'),
    Offenses: extractListWithId(formData.offenses, 'ptsStatuteID'),
  };
  return newForm;
};
const extractListWithId = (arr = [], filedName) => {
  const newArr = arr.map((item) => item[filedName]);
  return newArr;
};

const formatDate = (data, type, format) => {
  let formatedDate = '';
  if (type === 'from') {
    formatedDate = formatSaveDateFrom(data);
  } else {
    formatedDate = formatSaveDateTo(data);
  }
  return formatedDate ? formatedDate.split(' ')[0] : format == 'csv' ? null : '';
};

export const reportNameMapper = (id) => {
  switch (id) {
    case ReportIdConst.CitationReport:
      return 'Citation Report';
    case ReportIdConst.ActiveWarrantReport:
      return 'Warrant Report';
    case ReportIdConst.ActiveWarrantListWithMugshot:
      return 'Warrant Report with Mugshot';
    case ReportIdConst.IncidentByLocationSummary:
      return 'Incident By Location Summary';
    case ReportIdConst.IncidentByLocationDetail:
      return 'Incident By Location Details';
    case ReportIdConst.CleryReport:
      return 'RMS Clery Report';
    case ReportIdConst.CitationStatisticsReport:
      return 'Citation Statistics Report';
    case ReportIdConst.IncidentSeverityByZone:
      return 'Incident Severity by Zone';
    case ReportIdConst.OffenseChargesByState:
      return 'Offense Charges by State';
    case ReportIdConst.OffenseChargesByCity:
      return 'Offense Charges by City';
    default:
      return 'Report';
  }
};
